document.addEventListener('DOMContentLoaded', function () {
	$('.NAGroup').change(function() {
		var cb = this;
		var container = $(cb).parent().parent();
		if ( $(cb).is(":checked") ) {
			container.find('input[type=number], input[type=text]').val('').prop('disabled', 'disabled');
		} else {
			container.find('input[type=number], input[type=text]').prop('disabled', '');
		}
		
	});
});